// @flow
import React, { Component } from 'react'
import LabeledWrapper from './LabeledWrapper'
import { InputCell } from '../AudienceEdit'
import styled from 'styled-components'
import ErrorText from '../controls/ErrorText'
import I18n from 'node-polyglot'
import { Table, HeaderRow, HeaderCell } from '../MainTable'
import SegmentationItemsContainer from './SegmentationItemsContainer'

const SegmentationTable: typeof Table = styled(Table)`
  margin: 0;
`

const t = {
  label: 'Аудитории',
  count: 'шт.',
  limit_exceeded: 'Нельзя создать более %{count} аудиторий',
  name: 'Название',
  audience_size: 'Размер аудитории',
  price: 'Рекомендуемая цена'
}

type Props = {|
  segmentsCount: number,
  segmentItems: Array<Object>,
  isLimitExceeded: boolean,
  maxSegmentsCount: number
|}

export default class SegmentationPreview extends Component<Props> {
  render() {
    const { segmentsCount } = this.props
    return (
      <LabeledWrapper label={`${t.label} (${segmentsCount} ${t.count})`} twoLines>
        <InputCell>
          {this.props.isLimitExceeded ? (
            <ErrorText
              errors={[
                new I18n({ phrases: t }).t('limit_exceeded', {
                  count: this.props.maxSegmentsCount
                })
              ]}
            />
          ) : (
            <SegmentationTable className="t-SegmentItemsTable">
              <thead>
                <HeaderRow>
                  <HeaderCell alignLeft>{t.name}</HeaderCell>
                  <HeaderCell alignLeft>{t.audience_size}</HeaderCell>
                  <HeaderCell alignLeft>{t.price}</HeaderCell>
                </HeaderRow>
              </thead>
              <SegmentationItemsContainer segmentItems={this.props.segmentItems} />
            </SegmentationTable>
          )}
        </InputCell>
      </LabeledWrapper>
    )
  }
}
